// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"64d32ecc","980":"902ee876"}[chunkId] + ".chunk.css";
};